import { Tiptap } from '@shared/ui/tiptap';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface FormTextProps {
  onChange: (html: string) => void;
  properties?: unknown;
  isCanEdit?: boolean;
  content: string;
}

export const FormText = ({ onChange, properties, isCanEdit, content }: FormTextProps) => {
  return (
    <Tiptap
      {...stylex.props(styles.text)}
      onChange={onChange}
      properties={properties}
      defaultAlignment="center"
      editable={!isCanEdit}
      content={content}
    />
  );
};
